import { lazy } from 'react';

import { Navigate, Route, Routes } from 'react-router-dom';

import { useFeatureFlag } from '@packages/platform/feature-flags/use-feature-flag';
import { useRendallOrganization } from 'ae-kernel/organizations/use-rendall-organization';
import './locales/i18n';

const RisksPage = lazy(() => import('./pages/risks/risks.page'));
const RiskExposureOverview = lazy(
  () => import('./pages/risk-exposure-overview/risk-exposure-overview.page'),
);

const VulnerabilitiesPage = lazy(
  () => import('./pages/vulnerabilities/vulnerabilities.page'),
);

const AllRisksPage = lazy(() => import('./pages/all-risks/all-risks.page'));

const RiskDetailsPage = lazy(
  () => import('./pages/risk-details/risk-details.page'),
);

const RiskEvidencePage = lazy(
  () => import('./pages/risk-evidence/risk-evidence.page'),
);

const ViewRiskPage = lazy(() => import('./pages/view-risk/view-risk.page'));

export const RiskManagementRoutes = () => {
  const { currentOrganization, isPending } = useRendallOrganization();
  const [riskM1FF] = useFeatureFlag('RISKS_IN_UP_M1');

  if (!riskM1FF || (!isPending && !currentOrganization?.flags.risksInUpM1)) {
    return <Navigate to="/404" replace />;
  }

  return (
    <Routes>
      <Route path="risk-exposure-overview" element={<RiskExposureOverview />} />
      <Route path="risks" element={<RisksPage />}>
        <Route index element={<Navigate to="all" replace />} />
        <Route path="all" element={<AllRisksPage />} />
        <Route path="vulnerabilities" element={<VulnerabilitiesPage />} />
      </Route>
      <Route path="risks/:riskId" element={<ViewRiskPage />}>
        <Route index element={<Navigate to="risk-details" replace />} />
        <Route path="risk-details" element={<RiskDetailsPage />} />
        <Route path="risk-evidence" element={<RiskEvidencePage />} />
      </Route>
    </Routes>
  );
};
